import React from 'react';
import HomePageBlock from './HomePageBlock';

const HomePage = (): JSX.Element => {
  //const token = localStorage.getItem('access_token');

  /*if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }*/

  return <HomePageBlock />;
};

export default HomePage;
